export default {
    slot(h,conf) {
        return conf.text;
    }
}